// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2JSeU","title":"Info_title__IPnd0","selects":"Info_selects__cLiYd","requiredAsterisk":"Info_requiredAsterisk__1J0cF"};